import axios from 'axios';
import { serverUrl } from 'Config';
import AuthService from '../../AuthService';

class Http {
    get(url) {
        return axios({
            method: 'GET',
            url: serverUrl + url,
            headers: { 'Authorization': 'Bearer ' + AuthService.getToken() }
        });
    }
}

export default new Http();


// WEBPACK FOOTER //
// ./src/services/Cache/micro-services/http.js